module.exports = "/_next/static/images/8ef42a073c20b933b029c755a76002b4-fees-title.svg.webp";